import { ContractType } from "src/api-service";

// **************************************************************************
// CONTRACT TYPE STATE
// **************************************************************************
export interface ContractTypeState {
    contractType: ContractType | null;
    contractTypes: ContractType[];
    contractTypesLoading: boolean;
}

export const initialContractTypeState: ContractTypeState = {
    contractType: null,
    contractTypes: [],
    contractTypesLoading: false,
};
